<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.5 20.5H14.5M24.5 16H16.5M24.5 11.5H9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
